<script>
export default {
    name: "ReversalDepositModal",

    props: {
        showModal: Boolean,
        deposit: Object,
    },

    methods: {

        saveData() {
            this.$root.loading = true;
            this.$http.post(`Accounts/ReversePatientDepositPayments`, this.deposit).then(response => {
                this.$emit('refresh');
                this.$root.loading = false;
                this.$emit('closeModal');
                window.Swal.fire({ type: 'success', text: response.data });
            }).catch(() => {
                this.$root.loading = false;
                this.$emit('closeModal');
            });
        },
    }
}
</script>
<template>
    <tail-modal :show="showModal" dimension="w-1/2">
      <template v-slot:title>
        <h5 class="font-bold">Confirm Reverse Deposit</h5>
      </template>
      <template v-slot:modal-body>
        <div class="flex flex-wrap -m-3">
            <div class="md:w-1/4 sm:w-full p-1">
                <h5 class="font-bold">Patient: <span class="text-blue-700">{{ deposit.names }}</span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-1">
                <h5 class="font-bold">Receipt No: <span class="text-blue-700">{{ deposit.receiptNo }}</span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-1">
                <h5 class="font-bold">Trx Date: <span class="text-blue-700">{{ deposit.trxDate | dateFormat }}</span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-1">
                <h5 class="font-bold">Mode: <span class="text-blue-700">{{ deposit.mode }}</span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-1">
                <h5 class="font-bold">Deposit Amt: <span class="text-blue-700">{{ deposit.depositAmount | numberFormat }}</span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-1">
                <h5 class="font-bold">Allocated Amt: <span class="text-blue-700">{{ deposit.amountAllocated | numberFormat }}</span></h5>
            </div>
            <div class="md:w-1/4 sm:w-full p-1">
                <h5 class="font-bold">Unallocated Amt: <span class="text-blue-700">{{ deposit.unAllocatedAmount | numberFormat }}</span></h5>
            </div>
            <div class="w-full p-1 mt-2 border-t-2 border-gray-300">
                <label :for="`grid-memo-${deposit.receiptNo}`" class="label-control">Memo:</label>
                <textarea :id="`grid-memo-${deposit.receiptNo}`" v-model.trim="deposit.memo" cols="30" rows="2" class="input-control input-sm text-xs"></textarea>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-sm mr-4" @click.prevent="$emit('closeModal')"><i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-sm" @click.prevent="saveData"><i class="fa fa-check"></i> Reverse Deposit</button>
      </template>
    </tail-modal>
</template>